import React, { useState } from 'react';
import { Surface } from '@ukpostbox/frontend-framework';
import { BatteryEntryType } from './BatteryTypes';

function BatteryEntry(props: BatteryEntryType) {
	const [selected, setSelected] = useState(props.defaultSelected);

	const HandleCallback = () => {
		setSelected(!selected);
		props.callBack(!selected);
	};

	return (
		<div
			role='button'
			tabIndex={0}
			onClick={() => (!props.readOnly && !props.complete ? HandleCallback() : null)}
			onKeyDown={(e) => (e.key === 'Enter' && !props.readOnly && !props.complete ? HandleCallback() : null)}
			className={`upload-block ${selected ? 'primary' : ''} ${props.complete || props.readOnly ? 'disabled' : ''} align-stretch`}
		>
			<Surface>
				{props.media}
				<h5>{props.title}</h5>
				<ul>
					{props.description.map((entry) => (
						<li
							key={`description${props.name}${entry.value}`}
							className={entry.important ? 'list-alert' : ''}
						>
							{entry.value}
						</li>
					))}
				</ul>
			</Surface>
		</div>
	);
}

export { BatteryEntry };
